import { Injectable } from '@angular/core'
import { GbApiService } from '@galabid/shared/data-access-core'
import { Observable } from 'rxjs'
import { ImagesResponse } from './shared-images.models'

@Injectable({
  providedIn: 'root',
})
export class SharedImagesApiService extends GbApiService {
  uploadImage(urlName: string, image: File): Observable<ImagesResponse> {
    const url = `auctions/${urlName}/images/`

    const formData = new FormData()
    formData.append('image', image, image.name)

    return this.post<ImagesResponse>(url, formData)
  }

  getImageEntity(imageUuid: string): Observable<ImagesResponse> {
    const url = `blackboards/${imageUuid}/`
    return this.get<ImagesResponse>(url)
  }
}
